module.exports = {"610928100":"城关镇","610928101":"棕溪镇","610928102":"关口镇","610928103":"蜀河镇","610928104":"双河镇","610928105":"小河镇","610928106":"赵湾镇","610928107":"麻坪镇","610928108":"甘溪镇","610928109":"白柳镇","610928110":"吕河镇","610928111":"神河镇","610928112":"铜钱关镇","610928113":"段家河镇","610928114":"仙河镇","610928115":"金寨镇","610928116":"桐木镇","610928117":"构元镇","610928118":"石门镇","610928119":"红军镇","610928120":"仁河口镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610928.json
// module id = 2881
// module chunks = 0